import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { DataDirectoryHero } from '../components/data-directory/DataDirectoryHero';
import { DataDirectoryCategoryBrowser } from '../components/data-directory/DataDirectoryCategoryBrowser';
import { DataDirectoryCustomCta } from '../components/data-directory/DataDirectoryCustomCta';
import { DataDirectoryValueProps } from '../components/data-directory/DataDirectoryValueProps';
import { DataDirectoryFAQ } from '../components/data-directory/DataDirectoryFAQ';
import { DataDirectoryCta } from '../components/data-directory/DataDirectoryCta';
export function DataDirectory() {
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="min-w-full bg-slate-50/50 ecom-aeonik flex flex-col min-h-screen" style={{
    fontFamily: 'Aeonik, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  }} data-id="element-6336">
      <Navbar data-id="element-6337" />
      <main className="flex-grow pt-12 pb-24 space-y-12 md:space-y-24" data-id="element-6338">
        <DataDirectoryHero searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-6339" />
        <DataDirectoryCategoryBrowser searchQuery={searchQuery} data-id="element-6340" />
        <DataDirectoryCustomCta data-id="element-6341" />
        <DataDirectoryValueProps data-id="element-6342" />
        <DataDirectoryFAQ data-id="element-6343" />
        <DataDirectoryCta data-id="element-6344" />
      </main>
      <Footer data-id="element-6345" />
    </div>;
}